<template>

  <div>
    <div class="c-model-baner-text">
      <h2>Zadzwoń <a href='tel:324328480' class='red_text'>32 432 84 80</a><br>lub <a class='red_text show_form' v-on:click="askforofferfix()">wypełnij formularz</a></h2>
    </div>
    <div class="box_searcher-div">
      <div>
        <h3>Wybierz ofertę</h3>

        <select class="box_searcher" v-model="params.model_id" @change="cleanup_model(params.model_id),getOffers()">
          <option value="" disabled selected>Model</option>
          <option value="">Wszystkie</option>
          <option v-for="model in models" v-bind:key="model.id" v-bind:value="model.id" >{{ model.name }}</option>
        </select>

        <select class="box_searcher" v-model="params.price_to" @change="cleanup_params(params.price_to),getOffers()">
          <option value="" disabled selected>Cena</option>
          <option value="">Wszystkie</option>
          <option value="100000">do 100 000 zł</option>
          <option value="120000">do 120 000 zł</option>
          <option value="150000">do 150 000 zł</option>
          <option value="200000">do 200 000 zł</option>
          <option value="250000">do 250 000 zł</option>
          <option value="300000">do 300 000 zł</option>
          <option value="350000">do 350 000 zł</option>
          <option value="3500000">powyżej 350 000 zł</option>
        </select>
      </div>
    </div>
    <div class="c-model-list"  v-for="(offer, key) in offers" v-bind:key="key">
      <div class="rabat" v-if="offer.price_list != 0">
        Korzyść<br /><span>{{ priceFormat.to(calc(offer.price_list,offer.price)) }} zł</span>
      </div>
      <div class="c-model-list-image">
        <img class="c-model-list-image-car flank" v-bind:src="offer.photo" />
      </div>
      <div class="c-model-list-info">
        <h3 class="c-model-name">{{ offer.brand_name }} {{ offer.model_name }}</h3>
        <p>{{ offer.dealer_name }}</p>
        <p class="offer_number"></p>
        <div class="c-model-list-car-info">
          <div class="c-model-list-mini-info">
            <img class='max_power' src='@/assets/images/elem/max_power.png' />

            <div>
              <p class="c-model-list-car-header">Moc maksymalna:</p>
              <p class="c-model-list-car-text">{{ offer.power }} KM</p>
            </div>
          </div>
          <div class="c-model-list-mini-info">
            <img class='gearbox' src='@/assets/images/elem/gearbox.png' />
            <div>
              <p class="c-model-list-car-header">Skrzynia biegów:</p>
              <p class="c-model-list-car-text">{{ offer.transmission }}</p>
            </div>
          </div>
        </div>
        <div class="c-model-list-car-info">
          <div class="c-model-list-mini-info">

            <img class='fuel' src='@/assets/images/elem/fuel.png' />

            <div>
              <p class="c-model-list-car-header">Rodzaj paliwa:</p>
              <p class="c-model-list-car-text">{{ offer.fuel }}</p>
            </div>

          </div>
          <div class="c-model-list-mini-info">
            <img class='drive' src='@/assets/images/elem/drive.png' />

            <div>
              <p class="c-model-list-car-header">Rodzaj napędu</p>
              <p class="c-model-list-car-text">{{ offer.drive }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="c-model-list-prize">
        <div v-if="offer.price_list != 0">
          <p class="c-model-list-price fix">
            Cena katalogowa
          </p>
          <p class="c-model-list-wrong-prize">{{ priceFormat.to(offer.price_list) }} zł <a class="brutto">brutto</a></p>
        </div>
        <br />
        <div>
          <div>
            <p class="c-model-list-price">
              Cena
            </p>
            <p class="c-model-list-good-prize">{{ priceFormat.to(offer.price) }} zł <a class="brutto">brutto</a></p>
          </div>
          <!-- <br />
          <div>
            <p class="c-model-list-installament">w ofercie leasingu</p>
            <p class="c-model-list-installament-month">{{ priceFormat.to(offer.price_month) }} zł<a class="MC">/m-c*</a></p>
          </div> -->
        </div>
        <br />
        <div class="askforoffer_button no-mobile" v-on:click="askforoffer(offer.id)">
          Zapytaj o ofertę
        </div>
        <!-- <a :href="'https://www.piamarket.pl/szczegoly-oferty/'+offer.url+'/'+offer.id+'/'" target="_blank">
          <div class="askforoffer_button no-mobile askforoffer_check">
            Sprawdź szczegóły
          </div>
        </a> -->
      </div>
      <div class="askforoffer_button mobile" v-on:click="askforoffer(offer.id)">
        Zapytaj o ofertę
      </div>
      <!-- <a :href="'https://www.piamarket.pl/szczegoly-oferty/'+offer.url+'/'+offer.id+'/'" target="_blank">
        <div class="askforoffer_button mobile askforoffer_check">
          Sprawdź szczegóły
        </div>
      </a> -->


    </div>
    <div class="c-button-cars" @click="loadMore()" v-if="loader">
      POKAŻ WIĘCEJ OFERT
    </div>
    <a href="https://www.piamarket.pl/oferta/Audi/@/?limit=10&page_number=1&order=5&visit=1&category_id=1&city_names=Rybnik" @click="showOfferEvent()" target="
    ">
      <div class="c-button-cars c-button-cars-modify"  v-if="offers.length > 0" >
        Pokaż pełną ofertę Audi Rybnik
      </div>
    </a>
    <a href="https://www.piamarket.pl/oferta/Audi/@/?limit=10&page_number=1&order=5&visit=1&category_id=1&city_names=Sosnowiec" @click="showOfferEvent()" target="
    ">
      <div class="c-button-cars c-button-cars-modify"  v-if="offers.length > 0" >
        Pokaż pełną ofertę Audi Sosnowiec
      </div>
    </a>
    <div class="" v-if="offers == 0">
      <br><br><br>
    </div>
    <div class="c-legal-info">
      <p>
        Prezentowane informacje są wyłącznie informacją handlową i nie stanowi oferty w myślart. 66 § 1 i art. 556 indeks 1 Kodeksu Cywilnego. Porsche Inter Auto Polska zastrzega sobie prawo do doprecyzowania oraz korekt omyłek.
      </p>
    </div>
    <div class="c-model-baner-text" v-if="offers == 0">
      <h2>Brak ofert</h2>
    </div>
  </div>
</template>

<script type="text/javascript">
// import this.$http from 'this.$http'
import wnumb from 'wnumb'
import 'url-search-params-polyfill';

export default {
  name: 'offers',
  data: function data() {
    return {
      apiUrl: "https://webapi.porscheinterauto.com.pl/cars",
      params: {
        brand_id: 9,
        model_id: "",
        // dealer_id:19,
        dealer_ids:[
          19,
          22,
        ],
        limit: 8,
        offset: 0,
        price_from:0,
        price_to:"",
        page: 1,
        production_year_from:2018,
        production_year_to:2020,
        order: 1,
        ids: []
      },
      or_vins: [
        "viWAUZZZGB5KR057220",
        "viWAUZZZGE4KB014894",
        "viWAUZZZ8V2KA103528",
        "viWAUZZZGA2KA072294",
        "viWAUZZZF54KA050205",
        "viWAUZZZF47KA051940",
        "viWAUZZZF27KN086176",
        "viWAUZZZGAXKA087979",
        "viWAUZZZF31K1015474",
        "viWAUZZZF34K1003710",
        "viWAUZZZF39K1015836",
        "viWAUZZZF34K1015503",
        "viWAUZZZGA7KA087969",
        "viWAUZZZ4M3KD018211",
        "viWAUZZZFY7K2106688",
        "viWAUZZZF27KN007430",
        "viWAUZZZ4M6KD028313",
        "viWAUZZZ4M5KD012488",
        "viWAUZZZGA6KA088028",
        "viWAUZZZGA1LA018406",
        "viWAUZZZF58LA000778",
        "viWAUZZZGE0LB001299",
        "viWAUZZZGA4LA017928",
        "viWAUZZZF54LA000566",
        "viWAUZZZF34K1055841",
        "viWAUZZZ8V5KA087180",
        "viWAUZZZGA8KA058769",
        "viWAUZZZF44LA001451",
        "viWAUZZZF23KN040005",
        "viWAUZZZF25KN054536",
        "viWAUZZZF26KN055422"
      ],
      render_models: '',
      offers: [],
      models: {},
      loading: true,
      loader: true,
      priceFormat: wnumb({
        mark: "",
        thousand: " ",
        prefix: "",
        suffix: " "
      }),
    };
  },

  methods: {
    setModel: function setModel(val) {
      this.params.limit = 100;
      this.params.model_id = val;
      console.log(this.params.model_id);
    },
    getModels: function getModels() {
      var that = this;
      this.$http
      .get("https://webapi.porscheinterauto.com.pl/car-models?brand_id=9", {

      })
      .then(function(response) {
        that.models = response.data.models

        // console.log(that.models);
      })
      .catch(function() {
        window.alert("Sprawdź połączenie z internetem!");
      });
    },
    async getids() {
      const {data} = await this.$http
      .get("https://webapi.porscheinterauto.com.pl/car-ids", {
        params: {
          ...this.params,
          or_vins: this.or_vins
        }
      });
      this.params.ids = data.ids;
    },
    cleanup_model: function cleanup_model(value) {
      // this.$router.push({name: 'car=', query: { page: value } });
      gtag('event','Filtrowanie modelu: '+value);
      window.history.pushState(null, null, "?car=" + value);
      this.params.page = 1;
      this.offers = [];
    },
    cleanup_params: function cleanup_params(value) {
      if (value === '3500000') {
        this.params.price_to = value;
        this.params.price_from = 350000;
      }else{
        this.params.price_to = value;
        this.params.price_from = 0;
      }
      gtag('event','Wybranie ceny od '+value);
      this.params.page = 1;
      this.offers = [];
    },
    askforoffer: function askforoffer(value) {
      gtag('event','Kliknięcie zapytaj o ofertę nr: '+value);
      this.$store.dispatch('openForm', {data: true});
      this.$store.dispatch('changedesc', {data: 'Jestem zainteresowany ofertą nr. '+value});
      // document.getElementById('description').value = 'Jestem zainteresowany ofertą nr. ';
    },
    askforofferfix: function askforofferfix() {
      gtag('event','Kliknięcie zapytaj o ofertę nr: '+value);
      this.$store.dispatch('openForm', {data: true});
      this.$store.dispatch('changedesc', {data: ''});
    },
    calc: function calc(value1,value2) {
      return value1-value2;
    },
    getOffers: function getOffers() {
      var t = this;
      console.log("test");
      t.loading = true;

      this.$http
      .get(t.apiUrl, {
        params: t.params
      })
      .then(function(response) {
        if (t.offers.length != 0) {
          t.offers = t.offers.concat(response.data.cars);
        }else{
          t.offers = response.data.cars;
        }
        console.log(response.data.cars.length);

        if (response.data.cars.length < 8) {
          t.loader = false;
        }else{
          t.loader = true;

        }
      })
      .catch(function() {
        window.alert(
          "Błąd pobierania ofert. Sprawdź swoje połączenie z internetem"
        );
      })
      t.loading = false;
    },
    showOfferEvent: function showOfferEvent(){
      gtag('event','Kliknięcie w pokaż pełną ofertę');
    },
    loadMore: function loadMore() {
      var that = this;
      gtag('event','Kliknięcie pokaż więcej ofert');
      // this.load = true;
      this.params.page = this.params.page + 1;
      this.$http
      .get(that.apiUrl, {
        params: that.params
      })
      .then(function(response) {
        // that.offers = response.data.cars;
        if (response.data.cars.length > 0) {

          that.offers = that.offers.concat(response.data.cars);
          if (response.data.cars.length < 8) {
            that.loader = false;
          }else{
            that.loader = true;

          }
        }

      })
      .catch(function() {
        window.alert(
          "Błąd pobierania ofert. Sprawdź swoje połączenie z internetem"
        );
      })
    },
  },
  watch: {
    'params.ids': {
      handler: function handler() {
        this.getOffers();
      },
      deep: true
    },
    offers: {
      handler: function handler() {
        // console.log("test");
      },
      deep: true
    },
  },
  created: function created() {
    var that = this;
    that.getModels();

    var queryString = window.location.search;

    var urlParams = new URLSearchParams(queryString);

    urlParams.get('car')

    if (urlParams.get('car') != undefined) {
      that.params.model_id = urlParams.get('car').toLowerCase();
      console.log(that.params.model_id);
    }else{
      that.params.model_id = "";
    }
    this.getids();
    // this.getOffers();
    console.log("RDY 2 GO !");
  }
};
</script>
